import { NoteTripInput, TripOutput } from '@allocab/allocab-passenger-shared-types';
import { useMutation, useQueryClient } from '@tanstack/react-query';

import { mutationKeys } from '../services/datastore/mutationKeys';
import { queryKeys } from '../services/datastore/queryKeys';
import { passengerApi } from '../services/network/Api';
import { APIError } from '../services/network/types';

type Input = NoteTripInput & { jwtToken: string };

const createAnonymousNote = ({ jwtToken, ...input }: Input) =>
  passengerApi.post<NoteTripInput, TripOutput>('/anonymous/v1/trip/note', input, {
    headers: { Authorization: `Bearer ${jwtToken}` },
  });

const useCreateAnonymousNote = (jwtToken: string) => {
  const queryClient = useQueryClient();
  const createAnonymousNoteMutation = useMutation<TripOutput, APIError, NoteTripInput>({
    mutationKey: mutationKeys.createAnonymousNote(jwtToken),
    mutationFn: (input: NoteTripInput) => createAnonymousNote({ jwtToken, ...input }),
    onSuccess: trip => {
      queryClient.setQueryData(queryKeys.fetchAnonymousTrip(jwtToken), trip);
    },
  });

  return createAnonymousNoteMutation;
};

export default useCreateAnonymousNote;
